import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { SeguroAdesaoServices } from 'src/app/services/seguro/seguro-adesao.service';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

declare var $: any;
export interface DecSaude {
  
}

@Component({
    selector: 'app-tab3-declaracao-saude',
    templateUrl: './tab3-declaracao-saude.component.html',
    styleUrls: ['./tab3-declaracao-saude.component.css'],
    imports: [ReactiveFormsModule, FormsModule, NgxMaskDirective],
    providers: [SeguroAdesaoServices]
})
export class Tab3DeclaracaoSaudeComponent implements OnInit {

  @Input() idcAposentado: string;
  @Output() eventoSalvar = new EventEmitter<boolean>();

  loading: boolean = false;

  form: any = {
    DCR_PERGUNTA_01: null,
    DCR_JUSTIFICATIVA_01: '',

    DCR_PERGUNTA_02: null,
    DCR_JUSTIFICATIVA_02: '',
    
    DCR_PERGUNTA_03: null,
    DCR_JUSTIFICATIVA_03: '',
    
    DCR_PERGUNTA_04: null,
    DCR_JUSTIFICATIVA_04: '',
    
    DCR_PERGUNTA_05: null,
    DCR_JUSTIFICATIVA_05: '',
    
    DCR_PERGUNTA_06: null,
    DCR_JUSTIFICATIVA_06: '',
    
    DCR_PERGUNTA_07: null,
    DCR_JUSTIFICATIVA_07: '',
    
    DCR_PERGUNTA_08: null,
    DCR_JUSTIFICATIVA_08: '',
    
    DCR_PERGUNTA_09: null,
    DCR_JUSTIFICATIVA_09: '',
    
    DCR_PERGUNTA_10: null,
    DCR_JUSTIFICATIVA_10: '',
    
    DCR_PERGUNTA_11: null,
    DCR_JUSTIFICATIVA_11: '',
    
    DCR_PERGUNTA_12: null,
    DCR_JUSTIFICATIVA_12: '',
    
    DCR_PERGUNTA_13: null,
    DCR_JUSTIFICATIVA_13: '',
    
    DCR_PERGUNTA_14: null,
    DCR_JUSTIFICATIVA_14: '',

    VLR_PERGUNTA_15: null,
    VLR_PERGUNTA_16: null,

    DCR_PERGUNTA_17: null,
    DCR_JUSTIFICATIVA_17: ''
    
  }

  dados: any;

  constructor(private seguroAdesao: SeguroAdesaoServices) { }

  ngOnInit() {
    this.carregar();
  }

  salvar(){

    if(!this.validarForm()){
      return false;
    }

    this.loading = true;

    this.seguroAdesao
        .SalvarDeclaracaoDeSaude(this.form)
        .pipe(
          finalize(() => {this.loading = false})
        )
        .subscribe(
          (res: any) => {

            this.eventoSalvar.emit(true);
            $("#tabAdesaoSeguro a").addClass('disabled');
            $('#tabAdesaoSeguro a#btnTab4').removeClass('disabled').tab('show');
          },
          (http: HttpErrorResponse) => {

          }
        )
  }

  validarForm(): boolean{

    let f = this.form;

    if(f.DCR_PERGUNTA_01==null || f.DCR_PERGUNTA_02==null || f.DCR_PERGUNTA_03==null || f.DCR_PERGUNTA_04==null || f.DCR_PERGUNTA_05==null ||
       f.DCR_PERGUNTA_06==null || f.DCR_PERGUNTA_07==null || f.DCR_PERGUNTA_08==null || f.DCR_PERGUNTA_09==null || f.DCR_PERGUNTA_10==null ||
       f.DCR_PERGUNTA_11==null || f.DCR_PERGUNTA_12==null || f.DCR_PERGUNTA_13==null || f.DCR_PERGUNTA_14==null || f.VLR_PERGUNTA_15==null ||
       f.VLR_PERGUNTA_16==null || (this.idcAposentado=='S' && f.DCR_PERGUNTA_17==null)
      ){

        alert("Todos os campos são obrigatórios, por favor, responda todas as perguntas");
        return false;
    }

    if(f.DCR_PERGUNTA_01=='S' && (f.DCR_JUSTIFICATIVA_01==null || f.DCR_JUSTIFICATIVA_01.length==0)){
      alert("Responda a justificativa da Pergunta nº 1");
      return false;
    }

    if(f.DCR_PERGUNTA_02=='S' && (f.DCR_JUSTIFICATIVA_02==null || f.DCR_JUSTIFICATIVA_02.length==0)){
      alert("Responda a justificativa da Pergunta nº 2");
      return false;
    }

    if(f.DCR_PERGUNTA_03=='S' && (f.DCR_JUSTIFICATIVA_03==null || f.DCR_JUSTIFICATIVA_03.length==0)){
      alert("Responda a justificativa da Pergunta nº 3");
      return false;
    }

    if(f.DCR_PERGUNTA_04=='S' && (f.DCR_JUSTIFICATIVA_04==null || f.DCR_JUSTIFICATIVA_04.length==0)){
      alert("Responda a justificativa da Pergunta nº 4");
      return false;
    }
    
    if(f.DCR_PERGUNTA_05=='S' && (f.DCR_JUSTIFICATIVA_05==null || f.DCR_JUSTIFICATIVA_05.length==0)){
      alert("Responda a justificativa da Pergunta nº 5");
      return false;
    }

    if(f.DCR_PERGUNTA_06=='S' && (f.DCR_JUSTIFICATIVA_06==null || f.DCR_JUSTIFICATIVA_06.length==0)){
      alert("Responda a justificativa da Pergunta nº 6");
      return false;
    }

    if(f.DCR_PERGUNTA_07=='S' && (f.DCR_JUSTIFICATIVA_07==null || f.DCR_JUSTIFICATIVA_07.length==0)){
      alert("Responda a justificativa da Pergunta nº 7");
      return false;
    }

    if(f.DCR_PERGUNTA_08=='S' && (f.DCR_JUSTIFICATIVA_08==null || f.DCR_JUSTIFICATIVA_08.length==0)){
      alert("Responda a justificativa da Pergunta nº 8");
      return false;
    }

    if(f.DCR_PERGUNTA_09=='S' && (f.DCR_JUSTIFICATIVA_09==null || f.DCR_JUSTIFICATIVA_09.length==0)){
      alert("Responda a justificativa da Pergunta nº 9");
      return false;
    }

    if(f.DCR_PERGUNTA_10=='S' && (f.DCR_JUSTIFICATIVA_10==null || f.DCR_JUSTIFICATIVA_10.length==0)){
      alert("Responda a justificativa da Pergunta nº 10");
      return false;
    }

    if(f.DCR_PERGUNTA_11=='S' && (f.DCR_JUSTIFICATIVA_11==null || f.DCR_JUSTIFICATIVA_11.length==0)){
      alert("Responda a justificativa da Pergunta nº 11");
      return false;
    }

    if(f.DCR_PERGUNTA_12=='S' && (f.DCR_JUSTIFICATIVA_12==null || f.DCR_JUSTIFICATIVA_12.length==0)){
      alert("Responda a justificativa da Pergunta nº 12");
      return false;
    }

    if(f.DCR_PERGUNTA_13=='S' && (f.DCR_JUSTIFICATIVA_13==null || f.DCR_JUSTIFICATIVA_13.length==0)){
      alert("Responda a justificativa da Pergunta nº 13");
      return false;
    }

    if(f.DCR_PERGUNTA_14=='S' && (f.DCR_JUSTIFICATIVA_14==null || f.DCR_JUSTIFICATIVA_14.length==0)){
      alert("Responda a justificativa da Pergunta nº 14");
      return false;
    }

    if(f.VLR_PERGUNTA_15 < 0.1 || f.VLR_PERGUNTA_15 > 3.00){
      alert("Erro: a ALTURA deve estar entre 0,1m e 3,00m");
      document.getElementById("altura").focus();
      return false;
    }

    if(f.VLR_PERGUNTA_16 < 1 || f.VLR_PERGUNTA_16 > 450){
      alert("Erro: o PESO deve estar entre 1Kg e 450Kg");
      document.getElementById("peso").focus();
      return false;
    }

    if(this.idcAposentado=='S' && f.DCR_PERGUNTA_17=='Invalidez' && (f.DCR_JUSTIFICATIVA_17==null || f.DCR_JUSTIFICATIVA_17.length==0)){
      alert("Responda a justificativa da Pergunta nº 17");
      return false;
    }

    return true;
  }

  carregar(){

    this.loading = true;

    this.seguroAdesao
        .CarregarDeclaracaoDeSaude()
        .pipe(
          finalize(() => {this.loading = false})
        )
        .subscribe(
          (res: any) => {
                        
            if(res!=null){
              this.form = res;
            }
            
          },
          (http: HttpErrorResponse) => {

          }
        )
  }

  proximo(){
    this.salvar();
  }

  voltar(){
    $("#tabAdesaoSeguro a").addClass('disabled');
    $('#tabAdesaoSeguro a#btnTab2').removeClass('disabled').tab('show');
  }
}
